import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class WithdrawService {

    static getAllWithdrawals(item = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getAllWithdrawals}`;

        const params = {
            page: item?.page || 1,
            limit: item?.limit || 25,
        };

        if (item?.search?.trim()) {
            params.search = item.search.trim();
        }

        if (item?.status) {
            params.status = item.status;
        }

        return axiosInstance.get(api, {
            params,
        });
    }

    static getSupportIncome(item = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getSupportIncome}`;

        const params = {
            page: item?.page || 1,
            limit: item?.limit || 25,
        };

        if (item?.search?.trim()) {
            params.search = item.search.trim();
        }

        if (item?.status) {
            params.status = item.status;
        }

        return axiosInstance.get(api, {
            params,
        });
    }

    static addSupportIncome(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addSupportIncome}`;
        return axiosInstance
            .post(api, data)

    }

    static getAllReferralIncome(item) {
        let api = `${API_BASE_URL}${API_PATHS.getAllReferralIncome}`;

        const params = new URLSearchParams();

        if (item?.page) {
            params.append("page", item.page);
        }

        if (item?.limit) {
            params.append("limit", item.limit);
        }
        if (item?.search) {
            params.append("search", item.search);
        }

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }

    static getAllFundTransfers(item) {
        let api = `${API_BASE_URL}${API_PATHS.getAllFundTransfers}`;

        const params = new URLSearchParams();

        if (item?.page) {
            params.append("page", item.page);
        }

        if (item?.limit) {
            params.append("limit", item.limit);
        }
        if (item?.search) {
            params.append("search", item.search);
        }

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static approveWithdrawal(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.approveWithdrawal}`;
        return axiosInstance
            .post(api, data)

    }


}

export default WithdrawService;
